var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    [
      _c(
        "div",
        {
          class: [
            _vm.$vuetify.breakpoint.xs
              ? "gradient-blue flex-col items-center"
              : "bg-white",
            "min-h-screen flex sm:justify-center overflow-hidden",
          ],
        },
        [
          _c(
            "div",
            { staticClass: "my-12" },
            [
              _vm.$vuetify.breakpoint.xs
                ? _c("v-img", {
                    attrs: {
                      src: "/Musicologie-White-Wordmark.png",
                      "max-width": "200",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: [
                "max-w-3xl w-full px-6",
                _vm.$vuetify.breakpoint.xs ? null : "upper-third",
              ],
            },
            [
              _c(
                "div",
                {
                  class: [
                    "w-full bg-white custom-shadow soli-round overflow-hidden",
                  ],
                },
                [
                  _c(
                    "v-container",
                    { staticClass: "ma-0 flex justify-center" },
                    [
                      _c(
                        "v-row",
                        { class: _vm.$vuetify.breakpoint.xs ? null : "tall" },
                        [
                          _vm.$vuetify.breakpoint.smAndUp
                            ? _c(
                                "v-col",
                                {
                                  staticClass:
                                    "col-6 gradient-blue flex align-center justify-center",
                                  staticStyle: {
                                    "background-color": "#228cbd",
                                  },
                                },
                                [
                                  _c("v-img", {
                                    attrs: {
                                      src: "/Musicologie-White-Wordmark.png",
                                      "max-width": "275",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            {
                              staticClass:
                                "xs:col-12 sm:col-6 align-self-center",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "headline soli-grey px-3 py-5" },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        `${
                                          _vm.hasErrors
                                            ? " Uh-oh"
                                            : "Hello, friend."
                                        }`
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "caption error--text px-3" },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.form.errors.email) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "form",
                                {
                                  on: {
                                    submit: function ($event) {
                                      $event.preventDefault()
                                      return _vm.submit.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "pa-3" },
                                    [
                                      _c("div", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !_vm.errors.google,
                                            expression: "!errors.google",
                                          },
                                        ],
                                        staticClass: "flex justify-center pb-3",
                                        attrs: { id: "googleSignIn" },
                                      }),
                                      _vm._v(" "),
                                      _vm.errors.google
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex justify-center error--text text-sm mb-6",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(_vm.errors.google) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("v-divider", { staticClass: "mt-3" }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex justify-center",
                                          staticStyle: {
                                            transform: "translateY(-13px)",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-sheet",
                                            { staticClass: "w-10 white" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "font-bold soli-grey flex justify-center",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                or\n                                            "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "caption pl-2.5 soli-grey",
                                          attrs: { for: "email" },
                                        },
                                        [_vm._v("Email")]
                                      ),
                                      _vm._v(" "),
                                      _c("SoliText", {
                                        ref: "email",
                                        attrs: {
                                          name: "email",
                                          label: "",
                                          email: true,
                                          required: "",
                                        },
                                        on: {
                                          focus: function ($event) {
                                            return _vm.scrollTo(
                                              _vm.$refs.email.$el
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.form.email,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "email", $$v)
                                          },
                                          expression: "form.email",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "caption pl-2.5 soli-grey",
                                          attrs: { for: "password" },
                                        },
                                        [_vm._v("Password")]
                                      ),
                                      _vm._v(" "),
                                      _c("SoliText", {
                                        ref: "password",
                                        attrs: {
                                          name: "password",
                                          label: "",
                                          required: "",
                                          password: true,
                                          show: _vm.show,
                                        },
                                        on: {
                                          focus: function ($event) {
                                            return _vm.scrollTo(
                                              _vm.$refs.password.$el
                                            )
                                          },
                                          append: function ($event) {
                                            _vm.show = !_vm.show
                                          },
                                        },
                                        model: {
                                          value: _vm.form.password,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "password", $$v)
                                          },
                                          expression: "form.password",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("v-checkbox", {
                                        attrs: {
                                          color: "primary",
                                          label: "Remember me",
                                          "on-icon": "check_box",
                                          "off-icon": "check_box_outline_blank",
                                        },
                                        model: {
                                          value: _vm.form.remember,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "remember", $$v)
                                          },
                                          expression: "form.remember",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "justify-end flex align-center",
                                            },
                                            [
                                              _vm.canResetPassword
                                                ? _c(
                                                    "Link",
                                                    {
                                                      staticClass:
                                                        "underline text-sm text-gray-600 hover:text-gray-900",
                                                      attrs: {
                                                        href: _vm.route(
                                                          "password.request"
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                Forgot your password?\n                                            "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("SoliBtn", {
                                                staticClass: "ml-3",
                                                attrs: {
                                                  gradient: "gradient-orange",
                                                  text: "Login",
                                                  icon: null,
                                                  loading: _vm.form.processing,
                                                  type: "submit",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      Object.keys(_vm.$page.props.errors).includes("expired") ||
      _vm.$page.props.status
        ? _c("SoliSnack", {
            attrs: {
              text: _vm.$page.props.errors.expired || _vm.$page.props.status,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }